module.exports = __webpack_public_path__ + "img/summon_wither.45437064.gif";